import { render, staticRenderFns } from "./ModalAtaComProcesso.vue?vue&type=template&id=efa89928&scoped=true"
import script from "./ModalAtaComProcesso.vue?vue&type=script&lang=js"
export * from "./ModalAtaComProcesso.vue?vue&type=script&lang=js"
import style0 from "./ModalAtaComProcesso.vue?vue&type=style&index=0&id=efa89928&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa89928",
  null
  
)

export default component.exports